
import { SQLCourse } from './types';
import { phase5Modules } from './phase5Modules';
import { researchLabModules } from './researchLabModules';

// Combine phase5 modules with research lab modules
const phase5ModulesEnhanced = [...phase5Modules, ...researchLabModules];

export const SQL_PHASE5_COURSE: SQLCourse = {
  id: "sql-phase5-future-tech",
  title: "Future SQL Technologies & Research Innovation Lab",
  description: "Explore cutting-edge SQL technologies including AI integration, quantum computing, blockchain, edge computing, future paradigms, and contribute to research innovation through hands-on experimentation and community collaboration. Features enhanced video tutorials with AWS console walkthroughs, synchronized code examples, and integrated assessments.",
  level: "expert",
  durationHours: 35, // Updated to reflect enhanced video content and features
  tags: ["AI Integration", "Quantum Computing", "Blockchain", "Edge Computing", "Future Tech", "Research", "Innovation", "Community", "Experimental", "Video Learning", "AWS Console"],
  imageSrc: "/placeholder.svg",
  image: "/placeholder.svg",
  modules: phase5ModulesEnhanced, // Use enhanced modules with research lab
  totalDuration: "18 hours", // Updated duration to reflect enhanced content
  requirements: [
    "Completion of Enterprise SQL Mastery course",
    "Advanced technology awareness",
    "Research and experimentation mindset",
    "Community collaboration interest",
    "Familiarity with AWS services (recommended)"
  ]
};
